export default __webpack_public_path__ + "static/popup-fbcd4f135ab185654aa80141a22058f6.png";